import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import DashboardLayout from "../components/Layouts/DashboardLayout";
import ViewProductVariantContent from "./AddProductVariant/ViewProductVariantContent";
import { BGColor02 } from "../configs/styles/muiThemes";
import { useDispatch, useSelector } from "react-redux";
import { getActiveBusinessInfo } from "../reducers/businessPreview/businessPreviewSlice";
import { getCountryNames } from "../reducers/catalog/CatalogSlice";
import ThreeDotLoader from "../components/ThreeDotLoader";
import { useLocation } from "react-router-dom";
import {
  getReviewChildProductDetailsAPI,
  getReviewProductDetailsAPI,
  getViewChildProductDetailsAPI,
  getViewProductDetailsAPI,
} from "../service/api_calls/catalog/CatalogAPI";
import {
  getOndcFullSpecificationAPI,
  getOndcSpecificationAPI,
} from "../service/api_calls/AddProduct/AddProductAPI";
import {
  prepareViewChildVariantProductData,
  prepareViewProductVariantData,
} from "../utils/validateAndPrepareVariant";

function ViewProductVariant() {
  const [productDetails, setProductDetails] = useState(null);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const [variantDetails, setVariantDetails] = useState(null);

  const dispatch = useDispatch();
  const location = useLocation();

  const { activeBusinessInfo, activeBusinessInfoLoader } = useSelector(
    (state) => state.businessPreview
  );

  const { countryList, countryListLoading } = useSelector(
    (state) => state.catalog
  );

  const autoFillCategotyInfo = (productDetails) => {
    if (activeBusinessInfo && productDetails) {
      const businessCat = productDetails?.productMainCategory?.[0] || null;
      const productCat = productDetails?.productSubCategory?.[0] || null;
      const prodSubCat = productDetails?.productSubCategory2?.[0] || null;

      const ondcMainCat = productDetails?.productMainCategory?.[0] || null;
      const ondcSubCat = productDetails?.productSubCategory?.[0] || null;

      const catData = {
        ...categoryInfo,
        ondcEnabled: productDetails?.ondcEnabled || "no",

        selectedBusinessCat: {
          code: businessCat?.code || "",
          name: businessCat?.value || "",
          status: "active",
        },
        selectedProductCat: {
          code: productCat?.code || "",
          value: productCat?.value || "",
          pcCode: productCat?.pcCode || "",
          status: "active",
          pscCode1: productCat?.pscCode1 || "",
        },
        selectedProductSubCat: {
          code: prodSubCat?.code || "",
          value: prodSubCat?.value || "",
          pcCode: prodSubCat?.pcCode || "",
          psCode: prodSubCat?.psCode || "",
          status: "active",
          pscCode2: prodSubCat?.pscCode2 || "",
        },
        selectedOndcCat: {
          code: ondcMainCat?.ondcCode || "",
          name: ondcMainCat?.ondcValue || "",
          status: "active",
        },
        selectedOndcSubCat: {
          pcCode: "",
          scCode1: ondcSubCat?.ondcSubCode || "",
          pscCode1: "",
          productSubCategory1: ondcSubCat?.ondcSubValue || "",
        },
      };

      console.log("CAT_DATA___ProdInfo:", productDetails);
      console.log("CAT_DATA___:", catData);
      setCategoryInfo(catData);
    }
  };

  const getProductData = async (productDetails) => {
    const masterProductVariantId = location?.state?.productId;
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const isReviewProduct = location?.state?.isReviewProduct || false;

    autoFillCategotyInfo(productDetails);
    const mainProductData = prepareViewProductVariantData({
      productInfo: productDetails,
      countryList,
    });
    setProductDetails(mainProductData);

    const specificationPayload = {
      pscCode1: `${productDetails?.productMainCategory?.[0]?.ondcCode}${productDetails?.productSubCategory?.[0]?.ondcSubCode}`,
      status: "active",
    };
    const fullSpecificationPayload = {
      domainCode: productDetails?.productMainCategory?.[0]?.ondcCode,
      status: "active",
    };
    const specification = await getOndcSpecificationAPI(specificationPayload);
    const fullSpecification = await getOndcFullSpecificationAPI(
      fullSpecificationPayload
    );

    let childVariants = null;

    if (isReviewProduct) {
      const status = "new,updated,active";
      childVariants = await getReviewChildProductDetailsAPI(
        masterProductVariantId,
        businessId,
        status
      );
    } else {
      childVariants = await getViewChildProductDetailsAPI(
        masterProductVariantId,
        businessId
      );
    }

    const childVariantsData = prepareViewChildVariantProductData({
      childVariants: childVariants?.details,
      specification,
      fullSpecification,
      selectedVariant: mainProductData?.selectedVariant,
      sVariants: productDetails?.variantInfo?.variants,
      unitOfMeasurementData: [],
    });

    console.log("childVariants", childVariants, childVariantsData);

    setVariantDetails(childVariantsData);
  };

  const getProductDetails = async () => {
    const productId = location?.state?.productId;
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const isReviewProduct = location?.state?.isReviewProduct || false;

    if (isReviewProduct) {
      const data = await getReviewProductDetailsAPI({ businessId, productId });
      if (data?.details) {
        getProductData(data?.details);
      }
    } else {
      const data = await getViewProductDetailsAPI(productId);
      if (data?.product) {
        getProductData(data?.product);
      }
    }
  };

  useEffect(() => {
    if (countryList?.length > 0) {
      getProductDetails();
    }
  }, [countryList]);

  useEffect(() => {
    const businessId = sessionStorage.getItem("selectedBusinessId");
    if (businessId) {
      if (!activeBusinessInfo) {
        dispatch(getActiveBusinessInfo(businessId));
      }
      dispatch(getCountryNames());
    }
  }, []);
  return (
    <Box sx={styles.container}>
      <DashboardLayout activeMenu="catalog">
        {activeBusinessInfoLoader ||
        !productDetails ||
        !categoryInfo ||
        !variantDetails ? (
          <ThreeDotLoader />
        ) : (
          <ViewProductVariantContent
            categoryData={categoryInfo}
            productInfo={productDetails?.productDetails}
            ondcDetails={productDetails?.ondcDetails}
            selectedVariant={variantDetails?.selectedVariant1}
            variantData={variantDetails?.variantData}
            tableHeader1={variantDetails?.tableHeader1}
            tableHeader2={variantDetails?.tableHeader2}
            mobileTableHeader={variantDetails?.mobileTableHeader}
            view
          />
        )}
      </DashboardLayout>
    </Box>
  );
}

export default ViewProductVariant;

const styles = {
  container: {
    backgroundColor: BGColor02,
  },
};
